import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { Verlofsoort } from '@functieloonhuis/shared';
import { verlofApi } from '../../../lib/verlofApi';
import { approvalQueueKeys } from './useApprovalQueue';
import { leaveKeys } from './useMijnVerlof';

/**
 * Story 5.5: HR corrigeert de soort zolang de aanvraag niet is besloten (FR-2).
 *
 * De correctie herschrijft op de server ook de boek-as en de HR-route, en
 * daarmee bij wie de aanvraag ligt. Alle drie de lezers moeten dus opnieuw
 * ophalen: de goedkeuringslijst, het eigen overzicht van de medewerker en de
 * aanwezigheidskalender.
 */
export function useCorrigeerVerlofsoort() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, verlofsoort }: { id: number; verlofsoort: Verlofsoort }) =>
      verlofApi.corrigeerVerlofsoort(id, verlofsoort),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: approvalQueueKeys.all });
      queryClient.invalidateQueries({ queryKey: leaveKeys.all });
      queryClient.invalidateQueries({ queryKey: ['aanwezigheidskalender'] });
    },
  });
}
